import {message} from "antd";
import {useNavigate} from "react-router-dom";
import {useDeleteSession} from "../../../../features/sessions";

export function useDeleteSessionHook(sessionId: number) {
  const deleteSessionMutation = useDeleteSession();
  const navigate = useNavigate();

  function deleteSession(): Promise<void> {
    return deleteSessionMutation
      .mutateAsync(sessionId)
      .then(() => {
        message.success("The selected session has been deleted successfully!");
        navigate("/calls");
      })
      .catch(() => {
        // Error message already shown by useDeleteSession hook
      });
  }

  return {
    deleteSession,
  };
}
